// FLAGS: none
// App Insights error boundary that also resets React Query error state.
import { QueryErrorResetBoundary } from "@tanstack/react-query";
import reportWebVitals from "@openup/shared/helpers/appInsights/reportWebVitals";
import AppInsightsWebVitalsReporter from "@openup/shared/helpers/appInsights/AppInsightsWebVitalsReporter";
import { Metric } from "web-vitals";
import {
  AppInsightsContext,
  AppInsightsErrorBoundary,
} from "@microsoft/applicationinsights-react-js";
import { FC, PropsWithChildren } from "react";
import { appInsights, reactPlugin } from "@src/utils/appInsights";
import { ErrorPageWithAppInsights } from "@src/components/wrappers/ErrorPageWithAppInsights";

reportWebVitals((m: Metric) => AppInsightsWebVitalsReporter(m, appInsights));

const ErrorBoundary: FC<PropsWithChildren> = ({ children }) => (
  <QueryErrorResetBoundary>
    {() => (
      <AppInsightsErrorBoundary
        appInsights={reactPlugin}
        onError={ErrorPageWithAppInsights}
      >
        <AppInsightsContext.Provider value={reactPlugin}>
          {children}
        </AppInsightsContext.Provider>
      </AppInsightsErrorBoundary>
    )}
  </QueryErrorResetBoundary>
);

export default ErrorBoundary;
